;(function ($) {
    var step = '';

    $(document).ready(function() {

        // validation masks
        $('.phone').mask('(000) 000-0000');

        $('#submit-connect').on('click', function(e) {
            validateForm();
        });


        $('.ajax-contact-form .cf-submit').on('click', function(e) {
            e.preventDefault();

            var value = $('.ajax-contact-form .cf-email').val();
            if(value) {

                $.ajax({
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    data: {
                        action: 'cf_send_message',
                        email: value,
                    },
                    success: function(res) {
                        resetForm();
                        $('.ajax-contact-form').html(res.replace('0', ''));

                    },
                    error: function(err) {
                        console.error(err);
                    }
                });
                return true;
            } else return false;

            sendMessage();

        });

        function resetForm() {
            $('.ajax-contact-form .cf-email').val('');
        }


    });

    //defining functions

    function formReset() {
        $('.validation-error').css('display','none');
        $('#quiz-form').trigger('reset');
    }

    //form handling functions


    function validateForm() {
        $('#quiz-form').validate({
            ignore:'',
            rules: {
                category: {required :true}
            },
            messages:
            {
                category:
              {
                  required:'Please select one.'
              }
            },
            errorPlacement: function(error, element) 
            {
                if ( element.is(':radio') ) 
                {
                    error.appendTo( element.parents('.quiz-step') );
                }
                else 
                { // This is the default behavior 
                    error.insertAfter( element );
                }
            },
            showErrors: function(errorMap, errorList) {
                this.defaultShowErrors();
            },
            submitHandler: function(form) {
                submitFields();
            }
        });
        
    }

    function submitFields(){
        var radio = $('#step-4 input:checked').val();
        var message = '';
        if(radio == 'new-business') {
            message = 'We look forward to learning more. A BrandJuice team member will follow-up with you directly.';
        } else if(radio == 'vendor-inquiries') {
            message = 'We’ll be in touch as soon as we see an opportunity for potential partnership.';
        } else if(radio == 'careers') {
            message = 'We look forward to learning more. A BrandJuice team member will follow-up with you directly.';
        } else {
            message = 'Thank you, we\'ll be in touch!';
        }
        $('#thanks').text(message);
        var cat = $('.radio-text input:checked').val(); 
        if(cat == 'careers') {
            var type = 'careers';
        } else {
            var type = 'general';
        }

        var form_elems = $('#quiz-form').serializeArray();

        //console.log({form_elems})

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: { 
                action: 'lead_gen',
                data:form_elems,
                form: type,
            },
            success: function(response) {
                if(response == 'false') {
                    $('#failed-captcha').fadeIn();
                } else {
                    $('#failed-captcha').hide();
                    $('#thanks').css('opacity', '1');
                    formReset();
                    setTimeout(function(){ $('#thanks').css('opacity', '0'); }, 3000);
                }
            }  
        });   

    }

})(jQuery);